import React, { useEffect, useRef, useState } from 'react';
import ReporteTabla from '../Modulos/ReporteTabla'
import Barra from '../Modulos/Barra';
import { MDBRow, MDBCol } from 'mdb-react-ui-kit';
import { FaSearch } from "@react-icons/all-files/fa/FaSearch";
import DataTable from 'react-data-table-component';
import DataTableExtensions from 'react-data-table-component-extensions';
import 'react-data-table-component-extensions/dist/index.css';
import { FaExpand } from '@react-icons/all-files/fa/FaExpand';
import { FaCompress } from '@react-icons/all-files/fa/FaCompress';
import './Css/reportes.css'
import axios from '../utils/axiosConfig';
import Swal from 'sweetalert2';
import ReporteTabla3 from '../Modulos/ReporteTabla3';
import ModalBaseLg from '../components/modals/modal-base-lg';
import FormModalReportePowerBi from '../components/formsSolicitudes/formModalReportePowerBi';
import ModalBaseSm from '../components/modals/modal-base-sm';

var miStorage = window.localStorage;
export default function Reportes() {

  const [groupedData, setGroupedData] = useState([]);
  const [data, setData] = useState([]);
  const [expandedRows, setExpandedRows] = useState([]);
  const [expandedRowId, setExpandedRowId] = useState(null);
  const [idPowerBiSelected, setIdPowerBiSelected] = useState();
  const [idTypeId, setIdTypeId] = useState();
  const [bitOpen, setBitOpen] = useState(false);
  const [bitInsert, setBitInsert] = useState(false);
  const [bitEdit, setBitEdit] = useState(false);
  const [bitDelete, setBitDelete] = useState(false);

  const [idEdit, setIdEdit] = useState(-1);
  const [selectedReporte, setSelectedReporte] = useState(null);

  const [newReportOpen, setNewReportOpen] = useState(false); // Estado para controlar el modal de nuevo reporte

  const onEditReport = (report) => {
    console.log("Editar reporte:", report);
    setIdEdit(report.Id_Reporte);
    setSelectedReporte(report);
    setNewReportOpen(true);
    // Aquí puedes abrir un modal o navegar a una página de edición
    // Por ejemplo, abrir un modal:
    // setShowEditModal(true);
    // setReportToEdit(report);
    // Swal.fire({
    //   title: 'Funcionalidad en desarrollo',
    //   text: 'La edición de reportes está en desarrollo.',
    //   icon: 'info',
    //   confirmButtonText: 'OK'
    // });
  };

  const handleClose = () => {
    setNewReportOpen(false);
    setIdEdit(-1);
    fetchReportes(); // Refrescar la lista de reportes al cerrar el modal
  };

  const handleNewReportOpen = () => {
    if (!bitInsert) {
      Swal.fire({
        title: 'Información',
        text: 'No tiene los permisos necesarios para acceder a esta página',
        icon: 'info',
        showConfirmButton: false,
        timer: 3000,
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      return;
    } else {
      setIdEdit(-1);
      setSelectedReporte(null);
      setNewReportOpen(true);
    }
  };

  const HandlePageByRole = async () => {
    let data = {
      pagina: "10",
    };

    try {
      const res = await axios.post(
        process.env.REACT_APP_SERVER + "/usuarios/getconfiguracionpagina",
        JSON.stringify(data),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("tkn")}`,
          },
          withCredentials: true,
        }
      );

      if (res.data.success === false) {
        window.location.href = "/";
      } else {
        // console.log("BIt permisos: ", res.data.data);
        if (res.data.data.length > 0) {
          setBitOpen(res.data.data[0].bitOpen);
          setBitInsert(res.data.data[0].bitInsert);
          setBitEdit(res.data.data[0].bitEdit);
          setBitDelete(res.data.data[0].bitDelete);

          if (res.data.data[0].bitOpen) {
            console.warn("Tienes todos los permisos");
          } else {
            Swal.fire({
              title: 'Información',
              text: 'No tiene los permisos necesarios para acceder a esta página',
              icon: 'info',
              showConfirmButton: false,
              timer: 3000,
              allowOutsideClick: false,
              didOpen: () => {
                Swal.showLoading();
              },
            }).then(() => {
              window.location.href = "/principal"; // Redirect to another page
            });
          }
        }
      }
    } catch (error) {
      console.error("Error al listar bit permisos:", error);
    }
  };

  const columns = [
    {
      name: (
        <span style={{ fontSize: '18px', fontWeight: '700', color: '#2B2B2B',  color: "#566A7F", padding: "10px", borderRadius: "8px" }}>
          Categorías
        </span>
      ),
      selector: "categoryName",
      sortable: false,
      cell: (row) => {
        if (!row.isReport) {
          return (
            <div onClick={() => handleRowClicked(row)}
              style={{ cursor: "pointer", fontWeight: "bold", backgroundColor: "inherit", padding: "10px", fontSize: "18px" }}>
              {row.categoryName}
            </div>
          );
        } else {
          return (
            <div
              onClick={(e) => { e.stopPropagation(); handleRowClicked(row); }}
              style={{ paddingLeft: "20px", color: "#566A7F", cursor: "pointer", fontSize: "16px" }}
            >
              {row.categoryName}
            </div>
          );
        }
      },
    },
    // // ⬇️ nueva columna
    // {
    //   name: "Acciones",
    //   width: "140px",
    //   ignoreRowClick: true,
    //   allowOverflow: true,
    //   button: true,
    //   cell: (row) => {
    //     if (!row.isReport) return null; // solo para reportes
    //     return (
    //       <button
    //         type="button"
    //         className="btn btn-sm btn-outline-primary"
    //         title={bitEdit ? "Editar reporte" : "Sin permiso de edición"}
    //         disabled={!bitEdit}
    //         onClick={(e) => {
    //           e.stopPropagation(); // no dispares el onRowClicked
    //           if (!bitEdit) {
    //             Swal.fire("Sin permisos", "No puedes editar reportes.", "info");
    //             return;
    //           }
    //           onEditReport(row);
    //         }}
    //       >
    //         Editar
    //       </button>
    //     );
    //   },
    // },
  ];



  const tableData = {
    columns,
    data: groupedData.flatMap((item) => {
      const isExpanded = expandedRows.includes(item.categoryName); // Verifica si la categoría está expandida
      return [
        item,
        ...(isExpanded
          ? item.reports.map((report) => ({
            ...report,
            categoryName: report.NombreReporte,
            isReport: true, // Marca como reporte
          }))
          : []),
      ];
    }),
  };

  // Función para manejar clics en una fila
  const handleRowClicked = (row) => {
    if (!row.isReport) {
      // Si es una categoría, alternar su expansión/colapso
      setExpandedRows((prevExpandedRows) => {
        if (prevExpandedRows.includes(row.categoryName)) {
          // Si ya está expandida, colapsarla
          return prevExpandedRows.filter((name) => name !== row.categoryName);
        } else {
          // Si no está expandida, agregarla
          return [...prevExpandedRows, row.categoryName];
        }
      });
    } else {
      // Si es un reporte, manejar el clic y enviar su ID
      // console.log("Reporte seleccionado:", row.Id_PowerBI);
      setIdPowerBiSelected(row.Id_PowerBI);
      setIdTypeId(row.IdBItype);

      // Aquí puedes manejar lógica adicional, como cargar datos o redirigir
    }
  };


  // Helpers de normalización
  const norm = (v) =>
    String(v ?? "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim()
      .toLowerCase();

  const toArray = (v) =>
    Array.isArray(v)
      ? v
      : String(v ?? "")
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean);

  const fetchReportes = async () => {
    axios
      .get(process.env.REACT_APP_SERVER + "/operaciones/getreportesbi", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("tkn")}`,
        },
      })
      .then((res) => {
        if (res.data.success === false) {
          Swal.fire(
            {
              title: "Error",
              text: res.data.message,
              icon: "error",
              confirmButtonText: "OK",
            }
          )
          return;
        }

        const fetchedData = res.data.data || [];
        const userRole = res.data.rol; // puede ser id o nombre
        const userRoleNorm = norm(userRole);

        // 1) Filtrar por rol autorizado
        const filtered = fetchedData.filter((item) => {
          // Soportar distintos nombres/campos (IDs o nombres) y distintos formatos (array o csv)
          const rawRoles =
            item.RolesAutorizadosIds ??
            item.RolesIds ??
            item.RolesAutorizados ??
            item.roles_autorizados ??
            "";

          const rolesListNorm = toArray(rawRoles).map(norm);

          // Si no trae roles, NO pasa el filtro
          if (!rolesListNorm.length) return false;

          // Coincidencia exacta (id/nombre normalizado)
          return rolesListNorm.includes(userRoleNorm);
        });

        console.log("Res Data Reportes BI: ", res.data);
        console.log("Reportes BI filtrados por rol:", filtered);

        // Si quieres tener el CSV de roles como array en cada item (opcional)
        // const withRolesArray = filtered.map(it => ({
        //   ...it,
        //   RolesAutorizadosArray: toArray(
        //     it.RolesAutorizadosIds ?? it.RolesIds ?? it.RolesAutorizados ?? it.roles_autorizados ?? ""
        //   ),
        // }));

        setData(filtered);

        // 2) Agrupar por categoría y ordenar
        const grouped = Object.values(
          filtered.reduce((acc, item) => {
            const cat = item.ReportCategoria || "Sin categoría";
            if (!acc[cat]) acc[cat] = { categoryName: cat, reports: [] };
            acc[cat].reports.push(item);
            return acc;
          }, {})
        );

        // Ordenar categorías y reportes
        grouped.sort((a, b) => String(a.categoryName).localeCompare(String(b.categoryName)));
        grouped.forEach((group) => {
          group.reports.sort((a, b) =>
            String(a.NombreReporte || "").localeCompare(String(b.NombreReporte || ""))
          );
        });

        setGroupedData(grouped);
      })
      .catch((error) => console.error(error));
  };



  useEffect(() => {
    HandlePageByRole();
    fetchReportes();
  }, []);


  return (
    <>
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">


          <div className="layout-page">
            <Barra />
            {bitOpen && (
              <div className="content-wrapper">

                <div className="container-fluid flex-grow-1 container-p-y">
                  <MDBRow>
                    <MDBCol md='2'>
                      <h4 className="fw-bold mb-4">Business Intelligence</h4>
                      <button
                        className='btn btn-primary float-start mt-2 mb-4 cursor-pointer'
                        onClick={() => { handleNewReportOpen() }}
                      >Nuevo Reporte</button>
                    </MDBCol>

                  </MDBRow>

                  <div class="row">
                    <div class="col-sm-3">
                      <div class="row">
                        <div class="col-sm-12 mb-3">
                          <div class="card" style={{background:"transparent", border:"none", boxShadow:"none"}}>
                            <div class="card-body" style={{ background: "transparent", color: "black", borderRadius: "8px"}}>
                              <DataTableExtensions
                                {...tableData} export={false} print={false} defaultSortAsc={true}
                              >
                                <DataTable
                                  defaultSortField="id"
                                  defaultSortAsc={true}
                                  highlightOnHover
                                  export={false}
                                  onRowClicked={handleRowClicked}
                                  conditionalRowStyles={[
                                    {
                                      when: (row) => row.isReport,
                                      style: {
                                        paddingLeft: "20px",
                                        color: "#566A7F",
                                        cursor: "pointer",
                                        textDecoration: "none",
                                        background: "linear-gradient(135deg, rgba(0, 102, 153, 0.1) 0%, rgba(77, 148, 199, 0.2) 100%)",
                                      },
                                    },
                                    {
                                      when: (row) => !row.isReport,
                                      style: {
                                        fontWeight: "bold",
                                        color: "#566A7F",
                                        cursor: "pointer",
                                        background: "linear-gradient(135deg, rgba(0, 102, 153, 0.2) 0%, rgba(77, 148, 199, 0.3) 100%)",
                                      },
                                    },
                                  ]}
                                />
                              </DataTableExtensions>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-9" >
                      {/* <div class="card" > */}
                      {/* <div class="card-body" > */}
                      {/* Generar boton para maximixar el grafico powerBI */}
                      {/* <ReporteTabla onActualizarTabla={contador} idPowerBi={idPowerBiSelected} /> */}
                      {idPowerBiSelected ? (
                        <ReporteTabla3 reportId={idPowerBiSelected} data={data} idTypeId={idTypeId} />
                      ) : (
                        <div className="text-center">
                          <h4 className="fw-bold mb-4">Seleccione un reporte para visualizar</h4>
                          <i className='bx bxs-report bx-lg'></i>
                        </div>
                      )}
                      {/* </div> */}
                      {/* </div> */}

                    </div>
                  </div>
                </div>

                <footer className="content-footer footer bg-footer-theme">
                  <div className="container-xxl d-flex flex-wrap justify-content-between py-2 flex-md-row flex-column">
                    <div className="mb-2 mb-md-0">
                      ©, Producto realizado por <a href="https://logiseguridad.com" target="_blank" className="footer-link fw-bolder"> Logiseguridad Ltda</a>
                    </div>

                  </div>
                </footer>

                <div className="content-backdrop fade"></div>
              </div>
            )}
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle"></div>
      </div>

      <ModalBaseSm
        isOpen={newReportOpen}
        title={idEdit !== -1 ? 'Editar Reporte' : 'Crear Reporte'}
        onClose={() => { handleClose() }}
        childComponent={
          <FormModalReportePowerBi
            initialData={idEdit !== -1 ? selectedReporte : {}}
            idEdit={idEdit}
            onCancel={() => { handleClose() }}
          />
        }
      />

    </>
  );
}
